export default __webpack_public_path__ + "static/media/robot1.cb0a2941.jpg";